<template>
  <b-list-group
    class="notification-list-container mt-3"
    v-if="notifications.length"
  >
    <div v-for="(notification, index) in notifications" :key="index">
      <b-list-group-item
        class="d-flex justify-content-between align-items-center"
      >
        <div>
          <div class="h6 text-muted mb-0">
            {{ notification.proposalName }}
          </div>

          <span class="notification-body" v-if="notification.type === 'new'">
            Analisar a nova proposta criada
          </span>
          <span v-else class="notification-body">
            {{ notification.text ? notification.text : "Proposal edited" }}
          </span>
        </div>
        <b-button
          size="xs"
          class="notification-body px-1"
          @click="markReadNotification(notification)"
          >Entendi</b-button
        >
      </b-list-group-item>
    </div>
  </b-list-group>

  <b-card v-else sub-title="No notification" class="text-center" />
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState(["notifications"]),
  },
  methods: {
    ...mapActions(["removeNotification"]),
    markReadNotification(notification) {
      this.removeNotification(notification);
    },
  },
};
</script>

<style>
.notification-list-container {
  height: calc(100% - 116px) !important;
  border: 0px !important;
}

.notification-body {
  font-size: 13px;
}
</style>
